var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.numberData == null)?_c('div',{staticClass:"price"},[_vm._v("-")]):_c('div',{staticClass:"price"},[_c('span',{staticClass:"big"},[_vm._v("￥"+_vm._s(_vm.numberData.big))]),(_vm.numberData.small != null)?_c('span',[_vm._v(_vm._s(_vm.numberData.small))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }